import {Pipe, PipeTransform} from '@angular/core';
import {PlanDef} from '../../models/PlansConfig';
import {BuildMembershipsCtx, computeLabels} from '../plans';

@Pipe({ name: 'planPricingDuration', pure: true })
export class PlanPricingDurationPipe implements PipeTransform {
    transform(plan: PlanDef, ctx: BuildMembershipsCtx) {
        return computeLabels(plan, ctx);
    }
}
